// The address of a product's page in the store, for the admin's links to it ("View in store").
// The framework does not know the app's routes: the app says how they are made with
// setStoreProductUrl(fn) — fn(product) → path — and until it does a product's page is
// /product/<pid>, the framework storefront's own.
let build = null

export const setStoreProductUrl = (fn) => {
  build = typeof fn === "function" ? fn : null
}

export const storeProductUrl = (product) => {
  if (!product?.pid) return null
  const path = build ? build(product) : null
  return path || `/product/${encodeURIComponent(product.pid)}`
}
